import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { comparisonRows } from '../data/comparison';
export function Comparison() {
  return <section className="w-full bg-bone py-20" aria-labelledby="comparison-title" data-id="element-29" data-mp="1g8kozg4blsk5">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-30" data-mp="1l6m8211qxrvm">
        <h2 id="comparison-title" className="font-display text-3xl font-black tracking-tight text-court-950 sm:text-4xl" data-id="element-31" data-mp="1pxuhgx32td8s">
          Sin Tenis 360 <span className="text-court-600" data-id="element-32" data-mp="1uzbg0ly38nm7">vs</span> Con Tenis 360
        </h2>

        <div className="mt-10 overflow-hidden rounded-3xl border border-court-950/10 bg-white" data-id="element-33" data-mp="1zuqqr50su3ee">
          <div className="hidden grid-cols-2 border-b border-court-950/10 text-[11px] font-bold uppercase tracking-[0.16em] sm:grid" data-id="element-34" data-mp="23z6sqv7akqoc">
            <p className="px-7 py-4 text-court-600" data-id="element-35" data-mp="28um6ln5aumkr">Sin Tenis 360</p>
            <p className="bg-court-950 px-7 py-4 text-ball" data-id="element-36" data-mp="9lffllpr7oo5">Con Tenis 360</p>
          </div>
          <ul data-id="element-37" data-mp="ejqqlzrsc57y">
            {comparisonRows.map(row => <li key={row.without} className="grid border-b border-court-950/10 last:border-0 sm:grid-cols-2" data-id="element-38" data-mp="1m18uttyfm7u3">
                <div className="flex items-start gap-3 px-7 py-5" data-id="element-39" data-mp="1h7w7dn5ho72x">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-clay" strokeWidth={3} aria-hidden="true" data-id="element-40" data-mp="1d96x43fqz5ni" />
                  <span className="text-sm leading-relaxed text-court-700" data-id="element-41" data-mp="24zuxvedie90n">{row.without}</span>
                </div>
                <div className="flex items-start gap-3 bg-court-950 px-7 py-5" data-id="element-42" data-mp="20zays59dkvbv">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-ball" strokeWidth={3} aria-hidden="true" data-id="element-43" data-mp="1vy3re7b59y5q" />
                  <span className="text-sm font-medium leading-relaxed text-white" data-id="element-44" data-mp="kk9gs5v3jixe">{row.with}</span>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}